import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './PriceContainer.scss';

// @ts-ignore
import { currencyFormatter } from '@mooncake/utils';
import { fetchDisplayPrice, formatLocale, sendEvent } from '../../../utils';

import CONFIG from '../../../config';
import moment from 'moment';

interface IPriceContainerProps {
  context?: IContent;
  product?: any;
}

const PriceContainer = ({ context, product }: IPriceContainerProps) => {
  const { global } = context;

  // @ts-ignore
  const currency = window.GeoRestrictedResources
    ? window.GeoRestrictedResources.STOREFRONT_CURRENCY_CODE
    : null;
  // @ts-ignore
  const locale = window.GeoRestrictedResources
    ? formatLocale(window.GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE)
    : null;
  // @ts-ignore
  const addProductUrl = window.Urls ? window.Urls.addProduct : null;

  const releaseDate = product.originalData.c_productReleaseDateTime;
  const preOrderable = releaseDate
    ? releaseDate && moment(releaseDate) > moment()
    : true;

  const displayPrice = fetchDisplayPrice(product);

  const productNewPriceExists =
    displayPrice.promotionalPrice &&
    (typeof displayPrice.promotionalPrice === 'number' ||
      typeof displayPrice.promotionalPrice === 'string');
  const productOldPriceExists =
    displayPrice.regular &&
    (typeof displayPrice.regular === 'number' ||
      typeof displayPrice.regular === 'string') &&
    displayPrice.regular !== displayPrice.promotionalPrice;

  return (
    currency &&
    locale && (
      <div className="comparison-price">
        {productNewPriceExists && (
          <div
            className={`price-after${
              productOldPriceExists ? ' with-price-before' : ''
            }`}
          >
            {product.originalData.type.master && !CONFIG.isUPC && (
              <div className="from">{global.from}</div>
            )}
            <div className="amount">
              {currencyFormatter(
                displayPrice.promotionalPrice,
                locale,
                currency,
                {
                  shouldKeepEmptyDecimals: false
                }
              )}
            </div>
          </div>
        )}
        {productOldPriceExists && (
          <div className="price-before">
            {currencyFormatter(displayPrice.regular, locale, currency, {
              shouldKeepEmptyDecimals: false
            })}
          </div>
        )}
        {CONFIG.isUPC && (
          <div className="action">
            <a
              href={addProductUrl + '?pid=' + product.id}
              className={'buynow'}
              onClick={(e) =>
                sendEvent(
                  `compare tab - add to cart - ${
                    product.originalData.variation_values
                      ? product.originalData.variation_values.Platform
                      : 'pcdl'
                  } - rainbow six extraction - ${product.name.edition.toLowerCase()}`,
                  {
                    PRODUCTID: product.id,
                    PRODUCTNAME: `${
                      product.originalData.variation_values
                        ? product.originalData.variation_values.Platform
                        : 'pcdl'
                    } - rainbow six extraction - ${product.name.edition.toLowerCase()}`
                  }
                )
              }
            >
              {global.buy}
            </a>
          </div>
        )}
      </div>
    )
  );
};

export default withContent(PriceContainer);
